import type { Trip } from '@/services/trips';

export type TripParticipant = {
  userId: string;
  email: string;
  name: string;
};

export const getTripParticipants = (
  trip: Trip | null | undefined,
  currentUserId: string,
): TripParticipant[] => {
  if (!trip) return [];

  const tripWithOwnerMeta = trip as Trip & {
    ownerName?: string;
    ownerEmail?: string;
  };

  const ownerId = trip.owner || currentUserId;
  const ownerName =
    tripWithOwnerMeta.ownerName?.trim() ||
    trip.collaborators?.find((collab) => collab.userId === ownerId)?.name?.trim() ||
    (ownerId === currentUserId ? 'You' : 'Trip Owner');
  const ownerEmail =
    tripWithOwnerMeta.ownerEmail?.trim() ||
    trip.collaborators?.find((collab) => collab.userId === ownerId)?.email ||
    '';

  const participants: TripParticipant[] = [
    {
      userId: ownerId,
      email: ownerEmail,
      name: ownerName,
    },
    ...(trip.collaborators || []).map((collab) => ({
      userId: collab.userId,
      email: collab.email,
      name: collab.name?.trim() || collab.email.split('@')[0] || 'Traveler',
    })),
    ...((trip.members || []).filter((memberId) =>
      memberId && memberId !== ownerId && !(trip.collaborators || []).some((collab) => collab.userId === memberId),
    ).map((memberId, index) => ({
      userId: memberId,
      email: '',
      name: `Traveler ${index + 1}`,
    }))),
  ];

  return participants.filter(
    (participant, index, self) =>
      Boolean(participant.userId) &&
      index === self.findIndex((candidate) => candidate.userId === participant.userId),
  );
};
